'use client';

import React, {useState, useEffect, useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DataContext from '@/contexts/DataContext';

import { logger } from '@/lib/default-logger';

export const workspaces = [
  { name: 'Devias', avatar: '/assets/workspace-avatar-1.png' },
  { name: 'Carpatin', avatar: '/assets/workspace-avatar-2.png' },
];

// export function WorkspacesPopover({ anchorEl, onChange, onClose, open = false }) {
export function ProjectsPopover({ anchorEl, onChange, onClose, open = false }) {
  const { setCurrentProject, setExternalURL } = useContext(DataContext);
  const projects = JSON.parse(localStorage.getItem("projects"));
  const navigate = useNavigate();
  // logger.debug('popover proj', projects);
  
  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      onClose={onClose}
      open={open}
      slotProps={{ paper: { sx: { width: '250px' } } }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      {projects?.map((project, index) => (
        <MenuItem
          // key={project.name}
          key={index}
          // onClick={() => {
          //   onChange?.(project.name);
          // }}
          onClick={() => {
            setCurrentProject(project);
            if (project.id) {
              setExternalURL(false);
              // logger.debug('navigate: new proj selected');
              const parsedProject = project.id.replace('p:', '');
              navigate(`/?proj=${parsedProject}`)
            }
            onChange?.(project.id); // closes the popover
          }}
        >
          <ListItemAvatar>
            <Avatar src={project.avatar} sx={{ '--Avatar-size': '32px' }} variant="rounded" />
          </ListItemAvatar>
          {project.name}
        </MenuItem>
      ))}
    </Menu>
  );
}
